import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: Array<{
    id: number;
    name: string;
  }>;
  categoryName?: string;
  totalRecords?: number;
}

const initialState: InitialState = {};

const getListDocFormSlice = createSlice({
  name: "getListDocForm",
  initialState,
  reducers: {
    getListDocFormStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getListDocFormSuccess: (
      state,
      action: PayloadAction<{
        data: Array<{
          id: number;
          name: string;
        }>;
        categoryName?: string;
        totalRecords: number;
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...(state.data ?? []), ...action.payload.data];
      state.categoryName = action.payload.categoryName;
      state.totalRecords = action.payload.totalRecords;
    },
    getListDocFormFailed: (state, action: PayloadAction<{ type: string }>) => {
      state = {
        status: ReduxStateType.ERROR,
        data: [],
        totalRecords: 0,
      };
    },
    resetDocForm: (state) => initialState,
  },
});

export const {
  getListDocFormStart,
  getListDocFormSuccess,
  getListDocFormFailed,
  resetDocForm,
} = getListDocFormSlice.actions;

export default getListDocFormSlice.reducer;
